import { OrderStatus } from '@src/core/buyerApiClient';
import { LayoutColors } from '@src/core/theme';
import { ReturnedValueType } from './sale';

export const getConvertedOrderStatusType = (status: OrderStatus): ReturnedValueType => {
  switch (status) {
    case OrderStatus.Created:
    case OrderStatus.AwaitingConfirmation:
      return { type: 'info', background: LayoutColors.justBlue };
    case OrderStatus.Expired:
      return { type: 'warning', background: LayoutColors.warningDark };
    case OrderStatus.Confirmed:
      return { type: 'success', background: LayoutColors.successDark };
    case OrderStatus.PaymentVoided:
    case OrderStatus.PaymentChargedBack:
    case OrderStatus.Canceled:
      return { type: 'danger', background: LayoutColors.errorMain };
  }
};
